var React = require('react');

function Tiktok (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M12 22.5471C17.825 22.5471 22.5471 17.825 22.5471 12C22.5471 6.17499 17.825 1.45288 12 1.45288C6.17499 1.45288 1.45288 6.17499 1.45288 12C1.45288 17.825 6.17499 22.5471 12 22.5471Z","strokeWidth":"1.59601","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M16.6504 9.38155C15.6165 9.58204 13.5412 8.69327 12.8469 6.61197V14.9192C12.8469 16.8075 10.0803 18.4579 8.14265 16.5202C6.205 14.5825 8.19951 11.9476 10.0444 11.9985","strokeWidth":"1.59601","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

Tiktok.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = Tiktok;

Tiktok.default = Tiktok;
